import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// material
import { Box, List, ListItem, Stack, Typography, Paper } from '@mui/material';

// schema
import { schema as commentsSchema } from '@/props-constants/student-schema/student-comments-schemas/schema';
import { getCommentsUiSchema } from '@/props-constants/student-schema/student-comments-schemas/ui-schema';

//utils
import { toastMessages } from '@/utils/toastMessages';

//css
import { useStyles } from './styles';

//comps
import StudentComment from '@/components/shared/Comment';

// API
import { signRequest, updateOnboardingComment } from '@/api';
import { setToast } from '@/store/slices/toastSlice';

// constants
import constants from '@/constants';
import { PartnerDataGetAndStore } from '@/store/actions/partnerActions';

export default function ApplicationSubmitted() {
    const dispatch = useDispatch();
    const classes = useStyles();

    const comments = useSelector((state) => state.partnerData.data.comments);
    const partnerId = useSelector((state) => state.partnerData.data._id);

    const [addAttachment, setAddAttachment] = useState(false);

    const onCommentSave = (formData) => {
        if (formData.comment) {
            return updateOnboardingComment(formData, partnerId);
        } else {
            dispatch(setToast(toastMessages.backendIssue));
        }
    };

    const onCommentSaveSuccess = (_data, setData) => {
        dispatch(PartnerDataGetAndStore());
        setAddAttachment(false);
        setData({});
    };

    const fileUploadConfig = {
        s3Postfix: partnerId && `${constants.envName}/${partnerId}`,
        awsConfig: constants.awsConfig,
        selfAuthApiCall: signRequest,
    };

    return (
        <Box p={5}>
            <Box mb={3}>
                <Stack sx={{ textAlign: 'center' }}>
                    <Typography className={classes.title}>
                        Your Application is now under review
                    </Typography>
                    <Typography className={classes.subtitle}>
                        The process usually takes 1-3 business days
                    </Typography>
                </Stack>
            </Box>
            <Box className={classes.commentContainer}>
                <Paper variant="outlined">
                    <Box p={3}>
                        <Typography variant="h6"> Next steps:</Typography>
                        <List>
                            <ListItem>
                                <Typography variant="h6">
                                    1. The team will review your application
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography variant="h6">
                                    2. Based on the details provided, documents will be verified
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography variant="h6">
                                    3. In case of any queries, the business service manager will get
                                    in touch with you.
                                </Typography>
                            </ListItem>
                            <ListItem>
                                <Typography variant="h6">
                                    4. In case of no queries, we will initiate an agreement and send
                                    it on your registered email via DocuSign.
                                </Typography>
                            </ListItem>
                        </List>
                    </Box>
                </Paper>
            </Box>
            <Box className={classes.commentContainer}>
                <Typography variant="h6" mb={1}>
                    <em> Comments</em>
                </Typography>
                <Paper variant="outlined">
                    <StudentComment
                        addAttachment={addAttachment}
                        setAddAttachment={setAddAttachment}
                        comments={comments && comments.length > 0 ? comments : []}
                        addComment={{
                            schema: commentsSchema,
                            commentsUiSchema: getCommentsUiSchema({
                                addAttachment: addAttachment,
                                type: 'partners',
                            }),
                            defaultData: {},
                            uploadConfig: fileUploadConfig,
                            submitButton: {
                                label: 'Save Comment',
                                color: 'success',
                                onClick: onCommentSave,
                                fullWidth: false,
                                className: classes.saveCommentButton,
                            },
                            onSuccessCallback: onCommentSaveSuccess,
                        }}
                    />
                </Paper>
            </Box>
        </Box>
    );
}
